import { create } from "zustand";
import { persist } from "zustand/middleware";
import { GOALS_STORE_STORAGE_KEY } from "@/apps/goals/constants";
import {
  requestPersonalGoalInit,
  requestPersonalGoalSpin,
  updatePersonalGoalRegionGroup,
} from "@/apps/goals/services/goalsApi";
import {
  GoalsScreen,
  GoalTemplate,
  PersonalGoalInitResponse,
} from "@/apps/goals/types";
import { getGoalsScreenFromInitData } from "@/apps/goals/utils/goalsState";

interface GoalsState {
  initData: PersonalGoalInitResponse | null;
  screen: GoalsScreen;
  loadUserData: (yandexId: string) => Promise<PersonalGoalInitResponse>;
  selectRegion: (
    yandexId: string,
    regionGroupId: number    
  ) => Promise<GoalsScreen>;
  spinGoal: (yandexId: string) => Promise<GoalTemplate>;
  activateGoal: () => void;
  openWheel: () => void;
}

export const useGoalsStore = create<GoalsState>()(
  persist(
    (set) => ({
      initData: null,
      screen: "loading",
      loadUserData: async (yandexId) => {
        const initData = await requestPersonalGoalInit(yandexId);

        set({
          initData,
          screen: getGoalsScreenFromInitData(initData),
        });

        return initData;
      },

      selectRegion: async (yandexId, regionGroupId) => {
        const initData = await updatePersonalGoalRegionGroup(
          yandexId,
          regionGroupId
        );
        const screen = getGoalsScreenFromInitData(initData);

        set({
          initData,
          screen,
        });

        return screen;
      },
      spinGoal: async (yandexId) => {
        const template = await requestPersonalGoalSpin(yandexId);

        set((state) => ({
          initData: state.initData
            ? {
                ...state.initData,
                current_assignment: template.current_assignment ?? null,
                program: {
                  ...state.initData.program,
                  templates: state.initData.program.templates.map(
                    (existingTemplate) =>
                      existingTemplate.template_id === template.template_id
                        ? template
                        : existingTemplate
                  ),
                },
              }
            : state.initData,
        }));

        return template;
      },
      activateGoal: () => {
        set({
          screen: "activeGoal",
        });
      },
      openWheel: () => {
        set((state) => ({
          initData: state.initData
            ? {
                ...state.initData,
                current_assignment: null,
              }
            : state.initData,
          screen: "wheel",
        }));
      },
    }),
    {
      name: GOALS_STORE_STORAGE_KEY,
      partialize: (state) => ({
        initData: state.initData,
      }),
    }
  )
);
